import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { useState } from 'react';
import type { AppRouter } from '@beacon/trpc/router';
import { apiUrl, getOrgSlug } from './api';
import { getAuthToken } from './auth-token';
import { TRPCProvider } from './trpc';

const TEN_MINUTES = 10 * 60 * 1000;

let browserQueryClient: QueryClient | undefined;

function getQueryClient() {
  if (!browserQueryClient) {
    browserQueryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: TEN_MINUTES,
          gcTime: TEN_MINUTES,
          refetchOnWindowFocus: false,
        },
      },
    });
  }
  return browserQueryClient;
}

export function BeaconTRPCProvider({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  const [trpcClient] = useState(() =>
    createTRPCClient<AppRouter>({
      links: [
        httpBatchLink({
          url: apiUrl('/trpc'),
          async headers() {
            const token = await getAuthToken();
            const slug = getOrgSlug();

            return {
              ...(token ? { authorization: `Bearer ${token}` } : {}),
              ...(slug ? { 'x-beacon-org-slug': slug } : {}),
            };
          },
        }),
      ],
    }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        {children}
      </TRPCProvider>
    </QueryClientProvider>
  );
}
